"use strict";
exports.__esModule = true;
var regex = /^(?:1|f(?:alse)?|n(?:o)?|off)$/;
function default_1(s) {
    return regex.test(s.trim().toLowerCase());
}
exports["default"] = default_1;
;
